'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentAddiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#4E7EFF",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.6658 41.5797H75.2125V25.1639H69.6658V41.5797Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M76 19.5882C76 17.6064 74.4058 16 72.4391 16C70.4725 16 68.8783 17.6064 68.8783 19.5882C68.8783 21.5699 70.4725 23.1763 72.4391 23.1763C74.4058 23.1763 76 21.5699 76 19.5882Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M57.8218 36.4694C55.6946 36.4694 53.97 34.7316 53.97 32.5881C53.97 30.4446 55.6946 28.7069 57.8218 28.7069C59.949 28.7069 61.6734 30.4446 61.6734 32.5881C61.6734 34.7316 59.949 36.4694 57.8218 36.4694ZM67.2342 32.5881V16.9345H61.6734V24.2372C60.6198 23.5557 59.1946 23.1764 57.8218 23.1764C52.6233 23.1764 48.4093 27.3902 48.4093 32.5881C48.4093 37.7861 52.6233 42 57.8218 42C62.848 42 67.2342 38.104 67.2342 32.5881Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M37.1752 36.4694C35.048 36.4694 33.3236 34.7316 33.3236 32.5881C33.3236 30.4446 35.048 28.7069 37.1752 28.7069C39.3026 28.7069 41.0269 30.4446 41.0269 32.5881C41.0269 34.7316 39.3026 36.4694 37.1752 36.4694ZM46.5877 32.5881V16.9345H41.0269V24.2372C39.9734 23.5557 38.5481 23.1764 37.1752 23.1764C31.9769 23.1764 27.7628 27.3902 27.7628 32.5881C27.7628 37.7861 31.9769 42 37.1752 42C42.2015 42 46.5877 38.104 46.5877 32.5881Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.4124 27.9663C14.6515 27.9663 13.1494 29.0805 12.5607 30.6472V25.4344C12.5607 23.2908 14.2851 21.5531 16.4124 21.5531C18.5396 21.5531 20.2641 23.2908 20.2641 25.4344V30.6472C19.6755 29.0805 18.1735 27.9663 16.4124 27.9663ZM20.2641 33.5985V41.4923H25.8109V25.8105C25.8158 25.6852 25.8249 25.5609 25.8249 25.4344C25.8249 20.2364 21.6108 16.0226 16.4124 16.0226C11.214 16.0226 7 20.2364 7 25.4344V41.4923H12.5468V33.5484C13.1257 35.1342 14.6379 36.2652 16.4124 36.2652C18.1479 36.2652 19.6322 35.1833 20.2383 33.6523L20.2641 33.5985Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpPaymentAddiAsset = forwardRef(PaymentAddiAsset);

export { VpPaymentAddiAsset as default };
